module.exports = __webpack_public_path__ + "062ef5cc2daad1460d4033112d962cd2.MP3";